import React from "react";
import "../styles/Language.css";
import Modal from "./Modal.jsx";
import Logo from "../assets/logoWhite.png";
import { Link } from "react-router-dom";
import { IoNotificationsOutline } from "react-icons/io5";
import { MdContactPhone } from "react-icons/md";
import { BsFillMenuButtonWideFill } from "react-icons/bs";
import Tooltip from "@mui/material/Tooltip";

const Header = ({ open, setOpen, handleOpen, handleClose }) => {
  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <div className="lang_header">
        <Link to="/">
          <Tooltip title={"Back To Home"} arrow>
            <img src={Logo} alt="lang_header_logo" className="lang_logo" />
          </Tooltip>
        </Link>
        <div className="lang_header_button">
          <ul id="menu">
            <li class="parent">
              <i className="res_feedback" aria-hidden="true">
                <BsFillMenuButtonWideFill />
              </i>
              <a className="lang_header_feedback_btn">Main Menu</a>
              <ul class="child">
                <li class="parent">
                  <span style={{ cursor: "pointer" }}>Local Government</span>
                  <ul class="child">
                    <li>
                      <Link to="/LGEnglish">English</Link>
                    </li>
                    <li>
                      <Link to="/LGUrdu">Urdu</Link>
                    </li>
                    <li>
                      <Link to="/LGPashto">Pashto</Link>
                    </li>
                  </ul>
                </li>
                <li class="parent">
                  <span style={{ cursor: "pointer" }}>Covid</span>
                  <ul class="child">
                    <li>
                      <Link to="/CovidEngTopics">English</Link>
                    </li>
                    <li>
                      <Link to="/CovidUrduTopics">Urdu</Link>
                    </li>
                    <li>
                      <Link to="/CovidPashtoTopics">Pashto</Link>
                    </li>
                  </ul>
                </li>
                <li class="parent">
                  <span style={{ cursor: "pointer" }}>General</span>
                  <ul class="child">
                    <li>
                      <Link to="/GeneralEngTopics">English</Link>
                    </li>
                    <li>
                      <Link to="/GeneralUrduTopics">Urdu</Link>
                    </li>
                    <li>
                      <Link to="/GeneralPashtoTopics">Pashto</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="parent">
              <Link to="/FeedBackForm">
                <i className="res_feedback" aria-hidden="true">
                  <MdContactPhone />
                </i>
                <span className="lang_header_feedback_btn">Feedback</span>
              </Link>
            </li>
            <li class="parent">
              <Tooltip title={"New Notifications"} arrow>
                <i
                  id="myBtn"
                  className="notification_icon"
                  aria-hidden="true"
                  onClick={handleOpen}
                >
                  <IoNotificationsOutline />
                </i>
              </Tooltip>
            </li>
          </ul>
          {/* <Link to="/FeedBackForm">
            <i className="res_feedback" aria-hidden="true">
              <MdContactPhone />
            </i>
            <span className="lang_header_feedback_btn">Feedback</span>
          </Link>
          <Tooltip title={"New Notifications"} arrow>
            <i
              id="myBtn"
              className="notification_icon"
              aria-hidden="true"
              onClick={handleOpen}
            >
              <IoNotificationsOutline />
            </i>
          </Tooltip> */}
        </div>
      </div>
    </>
  );
};

export default Header;

// <ButtonToolbar>
// <Dropdown title="Dropdown">
//   <Dropdown.Menu title="Right Item 2">
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//   </Dropdown.Menu>
//   <Dropdown.Menu title="Right Item 2">
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//   </Dropdown.Menu>{" "}
//   <Dropdown.Menu title="Right Item 2">
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//     <Dropdown.Item>Item 3-1-1</Dropdown.Item>
//   </Dropdown.Menu>
// </Dropdown>
// </ButtonToolbar>
